import './App.css';

import React from 'react';
import { useRef, useEffect, useState } from 'react';
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { InitApp } from './init';
import { InitAuth  } from "./components/Auth/auth.modules.js";
import { useAuth } from './components/Auth/store';

import Ref from './helpers/Reference';
import AuthService from './helpers/auth';
import {Auth} from './components/Auth/auth';
import {ShowWindDirectInRumb, round, loadActual, parseActual, loadGEO, loadPhoto, ShowLocaleDateTime, fromRefByDomain, isVisibleMainMenu, getMarkerPopupMaxHeight, isStationHasCamera }  from './helpers/helpers';
import {loadPrecTriangle, showPrecTriangle} from './helpers/helpers';

import { MapContainer, TileLayer, Marker, Pane, Popup, Polygon, Polyline, LayerGroup} from 'react-leaflet';
import { useMap, useMapEvent } from 'react-leaflet/hooks';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {flip} from 'turf';

import { Col, Row, Space, Popover, Tooltip } from 'antd';
import { LineChartOutlined, FundViewOutlined, CaretUpFilled, CaretDownFilled } from '@ant-design/icons';

import { LeftMenu } from './components/Menu/left.menu.js';
import { ChartWindows } from './components/ChartWindow/chartwindows';
import { Voltage } from './components/Voltage/voltage';
import { Event } from './components/Event/event';

import { SearchStation } from './components/SearchStation/search.station';
import { FilterStation } from './components/SearchStation/filter.station.js';
import { AreaStation } from './components/SearchStation/areas.station.js';
import { SearchByMCHS, SearchByAreas } from './components/SearchStation/search.helper.js';

import IcoHelp from './images/ico_help.svg';
import ImgLegend from './images/img_station_legend.png';

import References from './helpers/Reference';
import { useStationFilter } from './components/SearchStation/store.js';
import { Layers } from './components/layers/layers.js';
import { useLayers } from './components/layers/store.js';
import { useSubdomains } from './components/Subdomains/store.js';
import { EventSituation } from './components/Event/event.situation.js';
import { GetWarningGroupsInStation} from './components/ChartWindow/utils.js';
import { PhotoGallery } from './components/PhotoGallery/photo.gallery.js';

const router = createBrowserRouter([
    {
        path: "/",
        element: <Actual />,
        errorElement: <ErrorPage />,
    },
    {
        path: "/:stationUUID&description",
        element: <Actual chartWindowTab="description"/>,
        errorElement: <ErrorPage />,
    },    
    {
        path: "voltage",
        element: <Voltage />,
    }, 
    {
        path: "event",
        element: <Event />
    }
]);

export function PopupComplex( {complexes} ) {
    return (
        <div>
            {complexes.map(complex =>
                <div key={complex.uuid} className="pb-2">
                    <h3 className="mb-1">{complex.name}</h3>
                    {complex.sensors.map(sensor =>
                        <Row rel={sensor.uuid} key={sensor.uuid}>
                            <Col span={16}>{sensor.name}, <span >{sensor.last_value.unit}</span></Col>
                            <Col className="text-right b" span={8}>
                                {sensor.last_value.value}
                            </Col>
                        </Row>
                    )}
                </div>
            )}
        </div>
    )
}

const MarkerSmall = ( state, isPartial, isTech ) => {
    let className = `state-background_${state} marker`;
    if (isPartial)
        className += ' marker-partial';

    let html = '';
    if (isTech)
        html += '<div class="marker-small-tech"></div>';

    return L.divIcon({
        className: className,
        html: html
    })

}

const MarkerBig = ( state, title, isPartial, isTech ) => {
    let className = `state-background_${state} marker-big helvetica-regular text-shadow`;

    if (isPartial)
        className += ' marker-partial';

    let html = `<div>${title}</div>`;
    if (isTech)                
        html += '<div class="marker-big-tech"></div>';


    return L.divIcon({
        className: className,
        html: html
    });    
}

const PopupMCHS = ( {station, isPopupOpened, onShowChartWindow, onHidePopup, onShowPhoto} ) => {

    const MARKER_POPUP_MAX_HEIGHT = 500;

    const [popoverHovered, setPopoverHovered ] = useState( false );
    const [ visibleGroups, setVisibleGroups ] = useState([]); 

    useEffect(() => {
        setPopoverHovered( isPopupOpened );
    }, []);

    useEffect(() => {
        if (!isPopupOpened)
            setVisibleGroups([]);
        else
            setVisibleGroups(GetWarningGroupsInStation( station ));
    }, [isPopupOpened])

    const handleClick = (e, station, mchsUUID ) => {
        AuthService.isForciblyAuth()
        .then(result => {
            if (result) {
                onShowChartWindow( station, mchsUUID );
            }
            else {
                InitAuth();
                useAuth.setState({isAuth: false});
            }
        });        
    };  

    const handleGroupChartClick = ( groupUUID ) => {
        AuthService.isForciblyAuth()
        .then(result => {
            if (result) {
                onShowChartWindow( station, groupUUID );
            }
            else {
                InitAuth();
                useAuth.setState({isAuth: false});
            }
        });        

    }
    
    const handleGroupClick = (uuid) => {
        const visible = visibleGroups;
        const index = visible.indexOf(uuid);
        if (index === -1)
            visible.push(uuid);
        else
            visible.splice(index, 1);
        setVisibleGroups([...visible]);
    }

    const onPopoverHoverChange = ( uuid, opened ) => {
        setPopoverHovered( opened ? uuid : null );
    }

    return (
        <div className="mt-2 popup-container-body" style={{maxHeight: isStationHasCamera(station) ? MARKER_POPUP_MAX_HEIGHT - 100 : MARKER_POPUP_MAX_HEIGHT}}>
            <PopupMCHSPhoto 
                station={station} 
                onShowChartWindow={onShowChartWindow} 
                isPopupOpened={isPopupOpened} 
                onHidePopup={onHidePopup}
                onShowPhoto={onShowPhoto}
            />                                                            
            {station.mchs.map((mchs, i) =>
                <div
                    key={`popup-marker-${mchs.uuid}`}
                >
                {mchs?.is_in_group && mchs.is_first_in_group &&
                    <PopupMCHSGroup 
                        uuid={mchs.group_id} 
                        mchUUID={mchs.uuid} 
                        groupName={mchs.group_name} 
                        isVisible={visibleGroups.indexOf(mchs.group_id) !== -1} 
                        isPopupOpened={isPopupOpened} 
                        onClick={handleGroupClick} 
                        onChartClick={() => handleGroupChartClick(mchs.group_id)} 
                        onHidePopup={onHidePopup}
                        visibleGroups={visibleGroups}
                    />
                }
                {mchs.main ? 
                    (<PopupMCHSIndicator 
                        station={station} 
                        mch={mchs} 
                        isPopupOpened={isPopupOpened} 
                        popoverHovered={popoverHovered} 
                        onPopoverHoverChange={onPopoverHoverChange}
                    />) 
                :
                    (<PopupMCHSItem  
                        station={station} 
                        mch={mchs} 
                        index={i} 
                        visibleGroups={visibleGroups} 
                        isPopupOpened={isPopupOpened} 
                        popoverHovered={popoverHovered} 
                        handleClick={handleClick} 
                        onPopoverHoverChange={onPopoverHoverChange}
                        onHidePopup={onHidePopup}
                    />)
                }
                </div>
            )}
        </div>
    )
}

const PopupMCHSGroup = ({
    uuid, mchUUID, groupName, isVisible, isPopupOpened, onClick, onChartClick, onHidePopup}) => {    

    useEffect(() => {
        if (!isPopupOpened) 
            setIsExpanded(false);
    }, [isPopupOpened]);

    useEffect(() => {
        setIsExpanded(isVisible);
    }, [isVisible])

    const [isExpanded, setIsExpanded] = useState(isVisible);

    const onGroupClick = ( e, uuid ) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(uuid);
        setIsExpanded(!isExpanded);
    }

    const onGroupChartClick = ( e, uuid ) => {
        e.preventDefault();
        e.stopPropagation();
        onChartClick(uuid, mchUUID);
        onHidePopup();
    }

    return (
        <div key={`popup-mchs-group-${uuid}`} className="show-chart-window-btn">
            <div onClick={(e) => onGroupChartClick(e, uuid, mchUUID)}>
                <Row>
                    <Col span="22" className="bordert-eee ">
                        <Row className="d-flex align-item-center">
                            <Col span={2} className="pv-1 text-lg" onClick={(e) => onGroupClick(e, uuid)}>{isExpanded ? <CaretUpFilled /> : <CaretDownFilled />}</Col>                        
                            <Col span={22} className="pv-1">{groupName}</Col>                        
                        </Row>
                    </Col>                            
                    <Col span="2" className="d-flex align-item-center text-right text-lg b">
                        <LineChartOutlined 
                            onClick={(e) => onGroupChartClick(e, uuid, mchUUID)}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    )
}

const PopupMCHSItem = ({
    station, mch, visibleGroups, index, isPopupOpened, popoverHovered, handleClick, onPopoverHoverChange, onHidePopup
}) => {

    const {permission} = useAuth();

    const ShowWindDirect = ( mchs ) => {
        let str = mchs.mchs?.state?.last_value?.hasOwnProperty('direction_avg') ?
            ShowWindDirectInRumb(mchs.mchs.state.last_value.direction_avg)
                :
            '-'
        return `(${str})`;                
    }

    const ShowPopupMchsTime = ( mchs ) => {
        return !mchs.not_configured ? ShowLocaleDateTime(mchs.mchs.state.last_value.time) : References.dictionary.not_configured;
    }

    const ShowMchsValue = ( mchs ) => {
        return !mchs.not_configured ? mchs.value : References.dictionary.not_configured;
    }

    const ShowPrecIntens = ( mchs ) => {
        let str = mchs.mchs?.state?.last_value?.hasOwnProperty('precipitation_intens') ?
            round(mchs.mchs.state.last_value.precipitation_intens, References.mchs.precipitation.precision)
                :
            '-';
            return `(${str} ${References.mchs.precipitation.intens_unit})`;
    }    

    const SetVisibilityGroups = (mch) => {
        if (!mch?.is_in_group)
            return "block";

        if (visibleGroups.indexOf(mch?.group_id) != -1)
            return "block";

        return "none";
    }

    return (
        <div 
        key={mch.uuid} 
        onClick={permission?.permissions?.can_view_data_archive && !mch.not_configured && mch.chartType !== 'no' ? 
            (e) => {
                handleClick(e, station, mch.uuid)
                onHidePopup()
            } : null}
        className={permission?.permissions?.can_view_data_archive ? "show-chart-window-btn" : null}
        style={{display: SetVisibilityGroups(mch)}}        
    >
        <Row>
            <Col span={1} className={(index > 0 ? "bordert-eee" : "") + " pv-1"}>
                <div className="level_code_lamp">
                    <div level_code_text={mch.level_code === null ? Ref.no_data_code : mch.level_code}>&#9679;</div>
                </div>                            
            </Col>
            <Col span={12} className={(index > 0 ? "bordert-eee" : "") + " pv-1 d-flex align-item-center"}>                            
                <span className="ml-1 popup__mchs-typename">{mch.typeName}</span> 
            </Col>
            <Col span={5} className={(index > 0 ? "bordert-eee" : "") + " pv-1 text-right d-flex align-item-center"}>
                <Popover  
                    key={`popup_over_hover_${station.mchs.uuid}`}                              
                    placement="topLeft"
                    content={ShowPopupMchsTime( mch )}
                    trigger="hover"
                    onOpenChange={(opened) => onPopoverHoverChange(mch.uuid, opened)}                                
                    open={isPopupOpened && popoverHovered === mch.uuid}
                >
                <Popover  
                    key={`popup_over_click_${station.mchs.uuid}`}                              
                    placement="topLeft"
                    content={ShowPopupMchsTime( mch )}
                    trigger="click"
                    onOpenChange={(opened) => onPopoverHoverChange(mch.uuid, opened)}                                
                    open={isPopupOpened && popoverHovered === mch.uuid}
                >                               
                <Space  className="popup__mchs-value cursor-pointer">
                    {ShowMchsValue(mch)}
                    {mch.type === 'radiation' && !mch.not_configured &&
                        <span>({round(mch.mchs.state.last_value.uncertainty, 0)}%)</span>
                    }
                    {mch.type === 'wind' && !mch.not_configured &&
                        <span>{ShowWindDirect(mch)}</span>
                    }
                </Space>
                </Popover>
                </Popover>
            </Col>
            <Col span={4} className={(index > 0 ? "bordert-eee" : "") + " pv-1 pl-1 d-flex align-item-center text-right"}>
                <span className="popup__mchs-unit">{mch.unit}</span>
            </Col>
            <Col span={2} className="d-flex align-item-center text-right text-lg b">
                {permission?.permissions?.can_view_data_archive && !mch.not_configured && mch.chartType !== 'no' &&                                                           
                    <LineChartOutlined rel={mch.uuid}/>
                }
            </Col>

        </Row>
        {mch.has_hdi === 1 && 
            <Row className="rem b pb-1">
                <Col span={1}>&nbsp;</Col>
                <Col span={10}><div className="pl-1">Оценка ГО</div></Col>                                    
                <Col span={ (mch.mchs.state.last_value?.hdi_lead?.length | 0) > 8 ? 11 : 7} className="text-right d-flex align-item-center">
                    {Number.isFinite(mch.mchs.state.last_value?.hdi_ihr) &&
                        mch.mchs.state.last_value?.hdi_ihr.toFixed(1)                                
                    }
                    &nbsp;
                    ({mch.mchs.state.last_value?.hdi_lead})
                </Col>                            
            </Row>
        }
    </div>

    )
}

const PopupMCHSIndicator = ({station, mch, isPopupOpened, popoverHovered, onPopoverHoverChange}) => {

    const ShowPopupMchsTime = ( mchs ) => {
        return !mchs.not_configured ? ShowLocaleDateTime(mchs.mchs.state.last_value.time) : References.dictionary.not_configured;
    }

    const ShowMchsValue = ( mchs ) => {
        return !mchs.not_configured ? mchs.value : References.dictionary.not_configured;
    }

    return (
        <div 
        key={mch.uuid} 
        className="popup__mchs-indicator"        
    >
        <Row>
            <Col span={1} className="d-flex align-item-center">
                <div className="level_code_lamp level_code_lamp_sm">
                    <div level_code_text={mch.level_code === null ? Ref.no_data_code : mch.level_code}>&#9679;</div>
                </div>                            
            </Col>
            <Col span={13} className="d-flex align-item-center">                            
                <span className="ml-1 popup__mchs-typename">{mch.typeName}</span> 
            </Col>
            <Col span={4} className="text-right d-flex align-item-center">
                <Popover  
                    key={`popup_over_hover_${station.mchs.uuid}`}                              
                    placement="topLeft"
                    content={ShowPopupMchsTime( mch )}
                    trigger="hover"
                    onOpenChange={(opened) => onPopoverHoverChange(mch.uuid, opened)}                                
                    open={isPopupOpened && popoverHovered === mch.uuid}
                >
                <Popover  
                    key={`popup_over_click_${station.mchs.uuid}`}                              
                    placement="topLeft"
                    content={ShowPopupMchsTime( mch )}
                    trigger="click"
                    onOpenChange={(opened) => onPopoverHoverChange(mch.uuid, opened)}                                
                    open={isPopupOpened && popoverHovered === mch.uuid}
                >                               
                <Space  className="popup__mchs-value cursor-pointer">
                    {ShowMchsValue(mch)}
                </Space>
                </Popover>
                </Popover>
            </Col>
            <Col span={4} className={"pl-1 d-flex align-item-center text-right"}>
                <span className="popup__mchs-unit">{mch.unit}</span>
            </Col>
            <Col span={2} className="d-flex align-item-center text-right text-lg b">
                &nbsp;
            </Col>

        </Row>
        </div>
    )
}

const PopupMCHSPhoto = ({station, onShowChartWindow, onHidePopup, onShowPhoto}) => {

    const [ loaded, setLoaded ] = useState( false );
    const [ photo, setPhoto ] = useState();
    const [ photoState, setPhotoState ] = useState( -1 );
    const [ isShowPhoto, setIsShowPhoto ] = useState( false );  
    
    useEffect(() => {
        if (typeof station.photo != 'undefined' && Number.isFinite(station.photo.photo_id)) {
            setPhotoState( station.photo.state );
            loadPhoto(station.photo)
                .then((data) => {  
                    if ( data.hasOwnProperty('file_source')) {               
                        setPhoto( {
                            id: data.id,
                            src: data.file_source,
                            time: data.time
                        } );     
                        setIsShowPhoto( true );
                    } else {
                        setIsShowPhoto( false );
                    }
                    setLoaded( true );                
                });
        } else 
            setLoaded( true );
    }, []);

    const onPhotoGalleryIconClick = () => {
        onShowChartWindow(station, station.photo.uuid, 'photo')    
        onHidePopup()
    }

    const onPhotoClick = () => {
        onShowPhoto(photo)
    }

    const color = () => {
        return station?.state?.hasOwnProperty('level_code') && Ref.danger.hasOwnProperty(station.state.level_code) ? 
            Ref.danger[station.state.level_code].color : 
            Ref.danger.default.color
    }

    return (
            <>
                {isShowPhoto && 
                    <div className={ (isShowPhoto ? 'd-block' : 'd-none') + " popup-pic-photo"}>
                        {loaded ?           
                            <div className="pos-relative">     
                                <div className="popup-photo-open">
                                    <span onClick={onPhotoGalleryIconClick}><FundViewOutlined /></span>
                                </div>
                                <img src={"data:image/png;base64, " + photo.src} alt="" style={{borderColor: color()}} onClick={(e) => onPhotoClick(e)}/>
                            </div>
                            :
                            <div>Идет загрузка...</div>                    
                        }
                    </div>
                }
            </>
    );
}

export function Markers( {isAuth, stations, onShowChartWindow, foundedStation, resetFoundedStation, mchsFilter, mchsFilterOrAnd, areasFilter, onShowPhoto} ) {

    const map = useMap();
    const markerRefs = useRef([]);
    const stationMarkersPane = "stationMarkers";

    const [ zoom, setZoom ] = useState( map.getZoom() );
    const [ isPopupOpened, setIsPopupOpened ] = useState( false );
    const [ markersZIndex, setMarkersZIndex ] = useState( 400 );

    useEffect(() => {
        if (markerRefs.hasOwnProperty(foundedStation.uuid)) {
            markerRefs[foundedStation.uuid].openPopup();
            map.flyTo({lat: foundedStation.lat, lon: foundedStation.lon}, Ref.map.zoomBig);
            foundedStation = null;                
        }

    }, [foundedStation, resetFoundedStation] );

    const hidePopup = () => {
        map.closePopup();
        setIsPopupOpened( false );
    };

    useMapEvent('zoomstart', () => {
        hidePopup();
    });
    useMapEvent( 'zoomend', () => {
        setZoom( map.getZoom() );
    });
    useMapEvent('popupopen', function() {
        setIsPopupOpened( true );
    })
    useMapEvent('popupclose', function() {
        setIsPopupOpened( false );
    })

    const IsFilter = ( filter, orAnd, areasFilter, elem ) => {
        const condFilter = SearchByMCHS(elem, filter, orAnd );
        const condArea = SearchByAreas( elem, areasFilter );
        return condFilter && condArea;
    }

    const markers = (stations, mchsFilter, mchsFilterOrAnd, areasFilter, onShowPhoto) => {
        return stations.map(station  => {
            if (IsFilter(mchsFilter, mchsFilterOrAnd, areasFilter, station)) {
            return (
                <Marker
                    key={"marker" + station.uuid}
                    position={[station.lat, station.lon]}
                    icon={ zoom < Ref.map.zoomBig ? 
                        MarkerSmall(station.state.level_code, station.state.partial, station.state?.dataloggers_state_code) : 
                        MarkerBig(station.state.level_code, station.short_name, station.state.partial, station.state?.dataloggers_state_code) 
                    }
                    ref={(ref) => {
                        if ( ref )
                            markerRefs[ `${station.uuid}` ] = ref;
                    }}
                    eventHandlers={{
                        popupopen: () => {
                            setMarkersZIndex(map.getPane(stationMarkersPane).style.zIndex);
                            map.getPane(stationMarkersPane).style.zIndex = 400;                        
                        },
                        popupclose: () => {
                            map.getPane(stationMarkersPane).style.zIndex = markersZIndex;                        
                        }
                    }}

                >
                    <Popup 
                        key={"popup" + station.uuid} 
                        minWidth="400" 
                        className="map-popup"
                        onClose={() => {setIsPopupOpened(false)}}
                    >
                        <div className="popup-container">
                            <h2 className="leaflet-popup-content-header-custom" level_code={station.state.level_code}>{station.name}</h2>                        
                            <PopupMCHS station={station} isPopupOpened={isPopupOpened} onShowChartWindow={onShowChartWindow} onHidePopup={hidePopup} onShowPhoto={onShowPhoto}/>                            
                        </div>
                    </Popup>
                </Marker>
                )
            }
        })

    }

    const layerGroup = (stations, mchsFilter, mchsFilterOrAnd, areasFilter) => {
        const l = 
        <LayerGroup>
            {markers(stations, mchsFilter, mchsFilterOrAnd, areasFilter)}
        </LayerGroup>;

        useLayers.setState({showed_layers: {
            station: l
        }});
        return l;
    }

    return  (
        <Pane name={stationMarkersPane}>
            {markers(stations, mchsFilter, mchsFilterOrAnd, areasFilter, onShowPhoto)}
        </Pane>

    )    

}

export function PrecPolygons({polygons}) {

    const precOptions = { color: 'grey', border: '0' };

    return <div>
        {polygons.hasOwnProperty('features') &&
        polygons.features.map(( p ) =>
            <Polygon key={"prec_polygon_" + p.properties.uuid} pathOptions={precOptions} positions={p.geometry.coordinates[0][0]} />
        )}
    </div>
}

function PrecTrianglePolygons({polygons}) {
    return <div>
        {polygons.map(( p ) => 
            <Polygon  key={"prec_triangle_polygon_" + p.key} pathOptions={p.options} positions={p._latlngs[0]} >
                <Popup>{p.popup}</Popup>
            </Polygon>                
        )}
    </div>

}

export function WaterPolygons({polygons}) {
    const waterOptions = { color: 'blue', border: '0' };
    return <div>
        {polygons.hasOwnProperty('features') &&
            polygons.features.map(( p ) =>
            <Polyline  key={"water_polygon_" + p.properties.uuid} pathOptions={waterOptions} positions={p.geometry.coordinates[0]} />
        )}

    </div>
}

export const Map = ({openedStation, onShowChartWindow, onLoadActual }) => {

    const [ loaded, setLoaded ] = useState( false );    

    const [ loadingElem, setLoadingElem ] =  useState( null );
    const [ showPrecLayer, setShowPrecLayer ] = useState( false );
    const [ showPrecTriangleLayer, setShowPrecTriangleLayer ] = useState( false );
    const [ showPrecTriangleDate, setShowPrecTriangleDate ] = useState( null );
    const [ showWaterLayer, setShowWaterLayer ] = useState( false );
    const [ stations, setStations ] = useState([]);
    const [ foundedStation, setFoundedStation ] = useState([]);
    const [ resetFoundedStation, setResetFoundedStation] = useState( Math.random() );
    const [ precPolygons, setPrecPolygons ] = useState([]);
    const [ precTrianglePolygons, setPrecTrianglePolygons ] = useState([]);    
    const [ waterPolygons, setWaterPolygons ] = useState([]);

    const [ mchsFilter, setMCHSFilter] = useState([]);
    const [ mchsFilterOrAnd, setMCHSFilterOrAnd ] = useState('or');
    const [ areasFilter, setAreasFilter ] = useState([]);

    const { permission, isAuth, isAnonymus, isProcessing} = useAuth();
    const { subdomainSettings } = useSubdomains();
    const { mchs, areas } = useStationFilter();

    const [isShowPhoto, setIsShowPhoto] = useState(false);
    const [showedPhoto, setShowedPhoto] = useState(null);

    const mapRef = useRef();

    const updateActual = () => {
        return loadActual(false)
        .then((data) => {       
            let stations = parseActual(data);
            setStations(stations);
            if (onLoadActual)                            
                onLoadActual(stations);

        })
        .catch((e) => console.log(e));
    }

    useEffect(() => {
        
        //загружаем посты
        if (isAuth) {
            setLoaded(false);
            updateActual()
            .then(() => {
                setLoaded(true);                    
                useAuth.setState({isProcessing: false});
                setInterval(updateActual, Ref.refresh * 6000);
            });
        } else 
            setLoaded(true);
    }, [isAuth, isAnonymus]);

    useEffect(() => {
        setMCHSFilter( mchs.items );
        setMCHSFilterOrAnd( mchs.orAnd );
    }, 
    [ mchs ]);

    useEffect(() => {
        setAreasFilter( areas );
    }, [ areas ])

    useEffect(() => {
        if (openedStation && loaded) {            
            const station = stations.filter(val => val.uuid === openedStation.station);
            if ( station.length && !station[0]?.mchs[0].not_configured)
                onShowChartWindow( station[0], station[0]?.mchs[0]?.uuid, openedStation?.tab) ;
        }
    }, [ openedStation?.station, loaded ]);

    useEffect(() => {
        if (showWaterLayer) {
            loadGEO( 'wl' )
                .then((data) => {
                    setWaterPolygons( flip(data) );
                });
        }
        else
            setWaterPolygons([]);
    }, [showWaterLayer]);

    useEffect(() => {
        if (showPrecLayer) {
            loadGEO( 'prec' )
                .then((data) => {
                    setPrecPolygons( flip(data) );
                });

        }
        else
            setPrecPolygons([]);
    }, [showPrecLayer]);

    useEffect(() => {
        if (showPrecTriangleLayer) {
            setLoadingElem( 'precTriangle' );
            loadPrecTriangle( showPrecTriangleDate )
                .then(data => {
                    let rects = showPrecTriangle(mapRef, data);
                    setPrecTrianglePolygons( rects );
                    setLoadingElem( null );
                });

        } else 
            setPrecTrianglePolygons([]);
    }, [ showPrecTriangleLayer, showPrecTriangleDate ] );

    const onSearchStation = ( founded ) => {
        setResetFoundedStation( Math.random() );
        setFoundedStation( founded );
    };

    const onCheckedPrecLayer = (checked ) => {
        setShowPrecLayer( checked );
    }

    const onCheckedPrecTriangleLayer = ( checked, date ) => {
        setShowPrecTriangleLayer( checked );
        setShowPrecTriangleDate( date );
    }    

    const onCheckedWaterLayer = (checked ) => {
        setShowWaterLayer( checked );
    }

    const onMCHSFilter = ( filter, orAnd ) => {
        setMCHSFilter( filter );
        setMCHSFilterOrAnd( orAnd );
    }

    const onShowPhoto = (photo) => {
        setIsShowPhoto(true)
        setShowedPhoto(photo)
    }

    const onClosePhoto = () => {
        setIsShowPhoto(false)
    }


    const TILE_SOURCE = References.map.tiles;
    const startMenuPos = isVisibleMainMenu(permission) ? 70 : 10;

    return (
        <>
        {loaded ? (
            <>
                <MapContainer
                    center={fromRefByDomain(['map', 'center'], subdomainSettings)}
                    zoom={fromRefByDomain(['map', 'zoom', 'default'], subdomainSettings)}
                    zoomControl={false}
                    maxZoom={fromRefByDomain(['map', 'zoom', 'max'], subdomainSettings)}                    
                    minZoom={fromRefByDomain(['map', 'zoom', 'min'], subdomainSettings)}                    
                    scrollWheelZoom={true}
                    style={{ width: '100vw', height: '100vh' }}
                    ref={mapRef}
                    opacity="0.5"

                >
                    <TileLayer
                        opacity={Ref.map.tileOpacity}
                        url={TILE_SOURCE}
                    />
                {(isAuth && !isProcessing) &&
                <>                    
                    {precPolygons &&
                    <PrecPolygons polygons={precPolygons}/>
                    }
                    {showPrecTriangleLayer &&
                    <PrecTrianglePolygons polygons={precTrianglePolygons}/>
                    }

                    {showWaterLayer &&
                    <WaterPolygons polygons={waterPolygons} />
                    }
                    <Markers 
                        isAuth={isAuth} 
                        stations={stations} 
                        openedStation={openedStation} 
                        foundedStation={foundedStation} 
                        resetFoundedStation={resetFoundedStation} 
                        onShowChartWindow={onShowChartWindow} 
                        mchsFilter={mchsFilter} 
                        mchsFilterOrAnd={mchsFilterOrAnd}
                        areasFilter={areasFilter}
                        onShowPhoto={onShowPhoto}
                    />
                </>
                }
                </MapContainer>                
                {isAuth &&
                    <>
                    <LeftMenu />
                    <SearchStation stations={stations} onSearchStation={onSearchStation} loadingElem={loadingElem}  startPos={startMenuPos} />                    
                    <FilterStation stations={stations} startPos={startMenuPos} />                
                    <AreaStation startPos={startMenuPos} />                        
                    <Layers mapRef={mapRef} />                                                               
                    </>
                }

                {isShowPhoto && 
                    <PhotoGallery images={[showedPhoto]} start={0}  onClose={onClosePhoto}/>
                }

            </>
        ) : (
            <div className="loading loading-screen">&nbsp;</div>
        )}        
        </>
    );
}

export function Actual({chartWindowTab}) {

    const EVENT_TAB_NAME = 'event';

    const [isActualLoaded, setIsActualLoaded] = useState(false);
    const [actual, setActual] = useState([]);

    const [ station, setStation ] = useState(null);    
    const { isAuth, isAnonymus, isProcessing, permission } = useAuth();

    const [ stationOpened, setStationOpened ] = useState(null);    
    const [ chartTabOpened, setChartTabOpened ] = useState(null)

    const handlerShowChartWindow = ( station, mchs, tab, start, finish ) => {
        setStation( {station: station, mchs: mchs, tab: tab, start: start, finish: finish} );
    };

    const handlerCloseChartWindow = () => {
        setStation( null );
    };

    const handleActualLoaded = (actual) => {
        setActual(actual);
        setIsActualLoaded(true);
    }

    useEffect(() => {
        const stationOpenedStorage = localStorage.getItem('show_station');
        if (stationOpenedStorage) {
            setStationOpened(stationOpenedStorage);
            setChartTabOpened(EVENT_TAB_NAME);
            localStorage.removeItem('show_station');
        }
    },
    []);

    return (
        <div>
        {isProcessing ? (         
            <div className="loading loading-screen"></div>
        ) : (
            <>
            <div id="map">
                <Map 
                    openedStation={{station: stationOpened, tab: chartTabOpened}} 
                    onShowChartWindow={handlerShowChartWindow} 
                    onLoadActual={handleActualLoaded}
                />
                {isAuth && permission?.permissions?.can_view_event_data &&
                <EventSituation 
                    onShowChartWindow={handlerShowChartWindow}
                    isLoadingActual={isActualLoaded}
                    actual={actual}
                />
}
               <Popover
                                key={`popup_over_click_legend`}                              
                                placement="leftBottom"
                                content={
                                    <img src={ImgLegend} style={{ maxHeight: "80vh"}}/>
                                }
                                trigger={["click"]}
                                arrow={false}
                                overlayInnerStyle={{padding: 0, backgroundColor: "rgba(255, 255, 255, 0)", boxShadow: "none"}}
               >
                    <Tooltip 
                        title={References.dictionary.tooltips.button_station_legend} 
                        overlayInnerStyle={{color: "black"}} 
                        placement="left" 
                        color="white"
                        mouseEnterDelay={References.tooltip_delay}
                    >
                        <div className="position-absolute-btn circle md station-legend">
                            <img src={IcoHelp} />
                        </div>
                    </Tooltip>
               </Popover>

            </div>
            <ChartWindows station={station} onCloseChartWindow={handlerCloseChartWindow}/>
            <div className="policy">
            Сайт не предоставляет информацию о параметрах и состоянии окружающей среды 
            | <a href="https://leafletjs.com">leaflet</a> | <a href="https://portal.fppd.cgkipd.ru">Карта ФППД</a>                
            </div>            
            </>
        )}
        </div>
    )
}

export function ErrorPage() {
    return (<>
        <h1>Страница не найдена.</h1><div><a href="/">Вернуться на главную</a></div>
    </>);
}

InitApp();

function App() {

    const {isProcessing, isExpired} = useAuth();        
    const {subdomainSettings} = useSubdomains();

    useEffect(() => {
        document.title = fromRefByDomain(['title'], subdomainSettings);
    }, [subdomainSettings]);


    return (
        <div className="App" style={{ width: '100vw', height: '100vh' }}>
            {isProcessing ? (         
                <div className="loading loading-screen"></div>
            ) : (
                <>
                    <Auth isExpired={isExpired}/>
                    <RouterProvider router={router} />
                </>
            )}
        </div>
    );
}

export default App;